(function() {
  var desktopViewport, formData, format, inputEmailAfterInit, messages, navbarNotify, on_desktop, on_mobile, root,
    slice = [].slice;

  desktopViewport = function() {
    return $(window).width() >= '700';
  };

  root = typeof exports !== "undefined" && exports !== null ? exports : this;

  if (root.utils == null) {
    root.utils = {};
  }

  root.effects = {};

  root.controllers = {};

  root.components = {};

  root.variables = {};

  root.events = {};

  root.variables = {
    debug: true,
    controllers: {
      catchExceptions: false,
      logInit: false
    },
    navbarHeight: 50,
    breakpoints: {
      desktop_1: 749,
      desktop: 750,
      minWidth: 1000
    }
  };

  root.utils.consoleFallback = function() {
    if (typeof console === "undefined" || typeof console.log === "undefined") {
    console = { };
    console.log = function() {};
    };
  };

  root.utils.isBrowser = function(browser) {
    var isChrome;
    if (browser === 'chrome') {
      return isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    }
  };

  root.utils.isAtBreakpoint = function(breakpoint) {

    /* Detect if at breakpoints via labels corresponding to the SASS.
    Usage: mobile = isAtBreakpoint(mobile)
     */
    var breakpoints;
    breakpoints = root.variables.breakpoints;
    if (breakpoint === 'mobile' && window.is_mobile) {
      return $(window).width() < breakpoints.mobile;
    } else if (breakpoint === 'desktop') {
      return $(window).width() > breakpoints.desktop;
    } else if (breakpoint === 'tablet') {
      return $(window).width() > breakpoints.mobile;
    }
  };

  root.utils.getCurrentBreakpoint = function() {

    /* Get current breakpoint
     */
    var breakpoint, isCurrent, px, ref;
    ref = root.variables.breakpoints;
    for (breakpoint in ref) {
      px = ref[breakpoint];
      isCurrent = root.utils.isAtBreakpoint(breakpoint);
      if (isCurrent) {
        return breakpoint;
      }
    }
  };

  root.utils.responsiveJS = function(args) {

    /* Simple responsive JS.
    Usage:
      responsiveJS
        query: ($window) ->   # function that returns true if valid.
        query: 'tablet'  # pipes to isAtBreakpoint function
        enter: ->  # function that triggers upon entering
        exit: ->  # function that triggers upon existing
     */
    var base, responsiveJS;
    if ((base = root.utils)._responsiveJSQueries == null) {
      base._responsiveJSQueries = [];
    }
    root.utils._responsiveJSQueries.push(args);
    this.$window = $(window);
    (responsiveJS = (function(_this) {
      return function() {

        /* Go through all responsive queries.
        Find ones that match.
        Execute if entered.
         */
        var j, len, matched, ref, responsive, results1;
        ref = root.utils._responsiveJSQueries;
        results1 = [];
        for (j = 0, len = ref.length; j < len; j++) {
          responsive = ref[j];
          if (_.isFunction(responsive.query)) {
            matched = responsive.query(_this.$window);
          } else {
            matched = root.utils.isAtBreakpoint(responsive.query);
          }
          if (matched && !responsive.active) {
            responsive.active = true;
            if (typeof responsive.enter === "function") {
              responsive.enter();
            }
          }
          if (!matched && responsive.active) {
            responsive.active = false;
            results1.push(typeof responsive.exit === "function" ? responsive.exit() : void 0);
          } else {
            results1.push(void 0);
          }
        }
        return results1;
      };
    })(this))();
    return this.$window.on('resize', _.debounce(responsiveJS, 100));
  };

  root.utils.lockScroll = function(lock) {

    /* Lock scroll for desktop.
    Mobile requires specific touch event locking.
     */
    if (lock === void 0) {
      return $("html").toggleClass('no-scroll');
    } else if (lock) {
      return $("html").addClass('no-scroll');
    } else {
      return $("html").removeClass('no-scroll');
    }
  };

  root.utils.scrollTo = function($el, options) {
    var animate;
    animate = (function(_this) {
      return function() {
        var top;
        top = $el.offset().top;
        return $("html, body").animate({
          scrollTop: top - (options.offset || 0)
        }, options.speed || 1000, options.easing || 'easeInOutExpo');
      };
    })(this);
    if (options.delay) {
      return _.delay(animate, options.delay);
    } else {
      return animate();
    }
  };

  root.utils.cookies = {

    /* Cookie setters and getters
     */
    set: function(name, value, days) {
      var date, expires;
      if (days) {
        date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
      } else {
        expires = "";
      }
      return document.cookie = name + "=" + value + expires + "; path=/";
    },
    get: function(name) {
      var c, ca, i, nameEQ;
      nameEQ = name + "=";
      ca = document.cookie.split(";");
      i = 0;
      while (i < ca.length) {
        c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length, c.length);
        }
        i++;
      }
      return null;
    },
    "delete": function(name) {
      return setCookie(name, "", -1);
    }
  };

  root.utils.getControllerInstance = function(controllerName, $scope) {

    /* Utility function to get an instance of a controller easily.
     */
    var $controllers, controller, instances;
    if (!$scope) {
      $scope = $('html');
    }
    $controllers = $scope.find("[js-controller=\"" + controllerName + "\"]");
    instances = (function() {
      var j, len, results1;
      results1 = [];
      for (j = 0, len = $controllers.length; j < len; j++) {
        controller = $controllers[j];
        results1.push($(controller).data('js-controller'));
      }
      return results1;
    })();
    if (instances.length === 1) {
      return instances[0];
    }
    return instances;
  };

  root.utils.evalAttribute = function($element, attribute) {
    var ex;
    try {
      return eval("(" + ($element.attr(attribute)) + ")") || {};
    } catch (_error) {
      ex = _error;
      console.log("Get args exception: ", ex, $element, attribute);
      return {};
    }
  };

  root.utils.getArgs = function($element) {

    /* Utilify function to get evaluated arguments from the DOM.
     */
    return root.utils.evalAttribute($element, 'js-args');
  };

  root.utils.bindJSControllers = function($scope, force) {
    var bindJSFactory, ex, ref, tagname;
    if (force == null) {
      force = false;
    }

    /* Extremely light weight, anti framework DOM based JS execution model.
    An extremely simple implementation of web components, angular directives,
    react.js components.
    
    DOM elements with particular attributes will be automatically called:
       js-controller="controller"
       js-args="{foo: true}"
    
    Will be passed to a corresponding function in root.controllers
      i.e. root.controllers['controller']
    
    And passed the jQuery element as the first parameter and arguments as
    the second parameter.
    
    This system is the equivalent of calling `someFunction($(".selector), {})`
    and therefore has an extremely low complexity ceiling.
     */
    if (!$scope) {
      this.$scope = $('html');
    } else {
      this.$scope = $scope;
    }
    try {
      tagname = (((ref = this.$scope.get(0)) != null ? ref.tagName : void 0) != null) || '';
      console.log("Binding JS controllers/components for\n" + tagname + ":" + (this.$scope.get(0).className) + ". Force: " + force);
    } catch (_error) {
      ex = _error;
    }
    bindJSFactory = function(attrName, objectName, $scope) {

      /* Factory function to create binders for arbitrary attribute names.
       */
      this.attrName = attrName;
      this.objectName = objectName;
      this.loadedClass = attrName + "-loaded";
      this.selector = "[" + attrName + "]";
      if (!force) {
        this.selector += ":not(." + loadedClass + ")";
      } else {
        console.log("Forcing re-binding");
      }
      return $scope.find(selector).each((function(_this) {
        return function(index, el) {
          var bind, handler;
          bind = function($element) {
            var controller, handler, handlerFunc, options;
            handler = $element.attr(_this.attrName);
            options = root.utils.getArgs($element);
            controller = root[_this.objectName][handler];
            if (controller) {
              handlerFunc = new controller($element, options);
            } else if (root.variables.controllers.logInit) {
              console.log("Controller not found for handler " + handler);
            }
            $element.data(_this.attrName, handlerFunc);
            $element.addClass(_this.loadedClass);
            if (root.variables.controllers.logInit) {
              return console.log(handler + " initialized with", {
                options: options
              });
            }
          };
          if (root.variables.controllers.catchExceptions) {
            try {
              bind($(el));
            } catch (_error) {
              ex = _error;
              handler = $(el).attr(_this.attrName);
              console.error('Error initializing: ', handler, ex);
            }
          } else {
            bind($(el));
          }
        };
      })(this));
    };

    /* Initialize two different controller types:
    Controllers: for architectural logic that spans multiple components.
    Components: for reusable snippets isolated to a particular component.
     */
    bindJSFactory('js-controller', 'controllers', this.$scope);
    return bindJSFactory('js-component', 'components', this.$scope);
  };

  root.effects.handleFadeInOnLoad = function() {

    /* Handle fade in / out on load
     */
    if (window.is_safari) {
      window.onbeforeunload = function() {
        if (!window.ignoreUnloadHandler) {
          $("body").addClass('is-unloading');
        }
      };
      $(window).bind("pageshow", function(ev) {
        if (ev.originalEvent.persisted) {
          $("body").addClass('is-loading');
        }
      });
    } else {
      $(window).on('beforeunload', function() {
        if (!window.ignoreUnloadHandler) {
          $("body").addClass('is-unloading');
        }
      });
    }
    $("body").addClass('is-loading');
    $('a[href^="mailto:"]').on('click', function() {
      return window.ignoreUnloadHandler = true;
    });
    root.effects.resetAnimationState = function($scope) {
      var animated;
      if (!$scope) {
        this.$scope = $('html');
      } else {
        this.$scope = $scope;
      }
      animated = this.$scope.find('.animation');
      return animated.removeClass('animation--animated animation--animating');
    };
    return root.effects.handleScrollBasedAnimations = function() {

      /* Handle scroll based fade in based on .animation classes.
       */
      this.$zeroHeightHiddenHelperCls = 'zero-height-hidden-helper';
      this.$zeroHeightHiddenHelperClsWithDot = '.zero-height-hidden-helper';
      $.extend($.expr[':'], {
        zeroheight: function(el, index, meta) {
          var $el, ex, noHeight, overflowHidden;
          $el = $(el);
          try {
            noHeight = $el.height() === 0;
            overflowHidden = $el.css('overflow') === 'hidden';
          } catch (_error) {
            ex = _error;
            console.log('failed getting height', ex);
          }
          if (noHeight && overflowHidden) {
            return true;
          }
          return false;
        },
        notzeroheightparent: (function(_this) {
          return function(el, index, meta) {

            /* Account for instances where height of an element is 0.
            0 height = not visible.
             */
            var $el, $zero;
            $el = $(el);
            $zero = $el.closest(_this.$zeroHeightHiddenHelperClsWithDot);
            if ($zero.is(':zeroheight')) {
              return false;
            }
            return true;
          };
        })(this)
      });
      $(":zeroheight").each((function(_this) {
        return function(index, el) {

          /* Detect zero height elements with hidden overflows as effectively non visible.
           */
          var $el;
          $el = $(el);
          return $el.addClass(_this.$zeroHeightHiddenHelperCls);
        };
      })(this));
      this.$animatedCls = 'animation--animated';
      this.$animatingCls = 'animation--animating';
      this.$animationOnlyMobile = 'animation--mobile';
      this.$animationOnlyDesktop = 'animation--desktop';
      this.$delay = 10;
      this.$additionalDelay = 20;
      this.$queued = 0;
      this.getQueuedDelay = (function(_this) {
        return function() {
          var delay;
          delay = _this.$delay + (_this.$queued * _this.$additionalDelay);
          return delay;
        };
      })(this);
      this.$animationSelector = ".animation:in-viewport:not(." + this.$animatedCls + "):not(." + this.$animatingCls + "):not(:hidden):notzeroheightparent";
      this.elementsToAnimate = (function(_this) {
        return function() {
          var $toAnimate;
          $toAnimate = $(_this.$animationSelector);
          return $toAnimate;
        };
      })(this);
      this.animateInWindow = (function(_this) {
        return function() {

          /* Find elements that are not animated yet.
          TODO: need mobile control. animate groups for desktop vs mobile.
           */
          var $toAnimate;
          $toAnimate = _this.elementsToAnimate();
          return $toAnimate.each(function(index, el) {
            var $el;
            $el = $(el);
            $el.addClass(_this.$animatingCls);
            _this.$queued += 1;
            return _.delay(function() {
              $el.addClass(_this.$animatedCls);
              return _this.$queued -= 1;
            }, _this.getQueuedDelay());
          });
        };
      })(this);
      $(window).on('scroll', _.debounce(this.animateInWindow, 500));
      setInterval(this.animateInWindow, 200);
      return setInterval((function(_this) {
        return function() {
          return console.log("Queued: " + _this.$queued);
        };
      })(this), 10000);
    };
  };

  root.effects.handleNavbarFadeIn = function() {

    /* Fade in navbar if it's hidden
     */
    this.$navbar = $('[js-navbar]');
    if (this.$navbar.is(':hidden')) {
      return this.$navbar.addClass('notransition').delay(1000).fadeIn('slow', 'easeInOutExpo', (function(_this) {
        return function() {
          return _this.$navbar.removeClass('notransition');
        };
      })(this));
    }
  };

  root.effects.init = (function(_this) {
    return function() {
      root.effects.handleFadeInOnLoad();
      return root.effects.handleScrollBasedAnimations();
    };
  })(this);

  root.utils.tabs = function() {
    var expandHeader, expandedClass, layout, resizeHandler, tabGroupSelector, toggleClass;
    tabGroupSelector = '[js-init="tab-group"]';
    expandedClass = function(element) {
      return element.attr('js-expanded-class');
    };
    toggleClass = function(className, element, group, allowMultiple) {
      if (!allowMultiple) {
        group.removeClass(className);
      }
      return element.toggleClass(className);
    };
    expandHeader = function(header, headerGroup, allowMultiple) {
      if (expandedClass(header)) {
        return toggleClass(expandedClass(header), header, headerGroup, allowMultiple);
      }
    };
    layout = {
      wasDesktop: desktopViewport()
    };
    resizeHandler = function() {
      if (!layout.wasDesktop && desktopViewport()) {
        $(tabGroupSelector).trigger('resetTabs');
      }
      return layout.wasDesktop = desktopViewport();
    };
    $(window).resize(resizeHandler);
    return $(document).ready(function() {
      return $(tabGroupSelector).each(function(_, rawTabGroup) {
        var accordionHeaders, resetTabs, setup_header, tabContents, tabGroup, tabHeaders;
        tabGroup = $(rawTabGroup);
        tabHeaders = tabGroup.find('[js-role="tab-headers"]').children();
        accordionHeaders = tabGroup.find('[js-role="accordion-header"]');
        tabContents = tabGroup.find('[js-role="tab-content"]');
        setup_header = function(tabHeader, tabHeaders, tabIndex, options, callback) {
          options = options || {};
          options.toggle = options.toggle || false;
          options.effect = options.effect || false;
          return tabHeader.click(function() {
            var hideContent, showContent, tabContent, visibleTab;
            visibleTab = tabContents.filter(':visible');
            tabContent = $(tabContents[tabIndex]);
            hideContent = function(content, options, callback) {
              var duration;
              duration = options.toggle ? 400 : 200;
              if (options.effect === 'fade') {
                return content.fadeOut(duration, callback);
              } else if (options.effect === 'slide') {
                return content.slideUp(duration, callback);
              } else {
                return content.hide({
                  complete: callback
                });
              }
            };
            showContent = function(content, options, callback) {
              var duration;
              duration = options.toggle ? 400 : 200;
              if (options.effect === 'fade') {
                return content.fadeIn(duration, callback);
              } else if (options.effect === 'slide') {
                return content.slideDown(duration, callback);
              } else {
                return content.show({
                  complete: callback
                });
              }
            };
            if (options.toggle) {
              if (!tabContent.is(':visible')) {
                showContent(tabContent, options);
              } else {
                hideContent(tabContent, options);
              }
            } else {
              if (!tabContent.is(':visible')) {
                hideContent(visibleTab, options, function() {
                  return showContent(tabContent, options);
                });
              }
            }
            expandHeader(tabHeader, tabHeaders, options.toggle);
            if (callback) {
              return callback();
            }
          });
        };
        tabHeaders.each(function(i, rawElement) {
          return setup_header($(rawElement), tabHeaders, i, {
            toggle: false,
            effect: 'fade'
          }, function() {
            return expandHeader($(accordionHeaders[i]), accordionHeaders, false);
          });
        });
        accordionHeaders.each(function(i, rawElement) {
          return setup_header($(rawElement), accordionHeaders, i, {
            toggle: true,
            effect: 'slide'
          }, function() {
            return expandHeader($(tabHeaders[i]), tabHeaders, false);
          });
        });
        resetTabs = function() {
          tabContents.hide();
          $(tabContents[1]).show();
          expandHeader($(tabHeaders[1]), tabHeaders, false);
          return console.debug('Reset tabs!');
        };
        tabGroup.on('resetTabs', resetTabs);
        if (desktopViewport()) {
          return resetTabs();
        }
      });
    });
  };

  root.utils.swiper = function() {
    return $(document).ready(function() {
      return $('[js-swiper]').each(function(i, rawElement) {
        var $swiper, swiper;
        $swiper = $(rawElement);
        return swiper = $swiper.swiper({
          effect: 'fade',
          fade: {
            crossFade: true
          },
          simulateTouch: true,
          speed: 500
        });
      });
    });
  };

  root.utils.domMatch = function() {
    var runDomMatch;
    runDomMatch = function() {
      $('[data-hmw]').each(function(i, rawElement) {
        var element;
        element = $(rawElement);
        element.height(element.width());
        return console.debug('Applied hmw match');
      });
      $('[data-mhmh]').each(function(i, rawElement) {
        var element, target;
        element = $(rawElement);
        target = $(element.attr('data-mhmh'));
        element.css('min-height', target.height());
        return console.debug('Applied mhmh match');
      });
      return $('[data-js-valign]').each(function(i, rawElement) {
        var element, totalHeight;
        element = $(rawElement);
        totalHeight = element.height() + element.css('padding-top') + element.css('padding-bottom');
        element.css('margin-top', totalHeight / -2);
        element.css('top', '50%');
        return element.css('position', 'relative');
      });
    };
    $(document).ready(function() {
      runDomMatch();
      return console.debug('Initialized dom match');
    });
    return $(window).resize(runDomMatch);
  };

  root.utils.cart = function() {
    var cartUpdated, itemCounter;
    if (!$('body').hasClass('template-cart')) {
      itemCounter = $('[data-js-role="cartItemCounter"]');
      cartUpdated = function() {
        var count;
        count = CartJS.cart.item_count;
        itemCounter.text(count);
        if (count === 0) {
          itemCounter.fadeOut();
        } else {
          itemCounter.fadeIn();
        }
        itemCounter.toggleClass('navbar__cart-count--two-digits', count >= 10 && count < 100);
        return itemCounter.toggleClass('navbar__cart-count--too-much', count >= 100);
      };
      $(document).on('cart.ready', cartUpdated);
      $(document).on('cart.requestComplete', cartUpdated);
      return cartUpdated();
    }
  };

  root.init = function() {

    /* Modernizr to initialize this.
    $.load is too early before components load.
     */
    root.utils.tabs();
    root.utils.consoleFallback();
    root.effects.init();
    root.utils.bindJSControllers();
    root.utils.swiper();
    root.utils.domMatch();
    root.utils.cart();
    return $('body').addClass('is-loaded');
  };

  $(function() {
    return root.init();
  });

  root = typeof exports !== "undefined" && exports !== null ? exports : this;

  root.components.mailchimp = function($element, args) {
    var controller;
    controller = {};
    console.log('mailchimp init');
    controller.init = function() {
      var callback;
      callback = args.callback || controller.onAjaxChimpPOST;
      $element.ajaxChimp({
        callback: callback
      });
    };
    controller.onAjaxChimpPOST = function(data) {
      var $button, $error, e, msg;
      $error = $element.find('[js-mailchimp-error]');
      $element.removeClass('is-error');
      $error.html('');
      if (data.result === 'error') {
        $element.addClass('is-error');
        if (data.msg && data.msg.indexOf(' - ') >= 0) {
          msg = data.msg.split(' - ')[1];
        } else {
          msg = data.msg;
        }
        $error.html(msg);
        console.log('Error from ajaxChimp ', data);
      } else if (data.result === 'success') {
        $button = $element.find('input[type="submit"]');
        $button.html('DONE!');
        $element.find('input[type=email]').val('Thank You!');
        try {
          fbq('track', "Lead");
        } catch (_error) {
          e = _error;
        }
      } else {
        console.log('Unhandled AJAXChimp Response: ', data);
      }
      return data;
    };
    return controller.init();
  };

  root.components.quantity = function($element, args) {
    var quantityInput;
    return (quantityInput = (function(_this) {
      return function() {
        var $input, $mod, adjustVal;
        $input = $element.find('[js-cart-quantity-input]');
        $mod = $element.find('[js-cart-quantity]');
        $input.on('click', function() {
          return $input.get(0).select();
        });
        adjustVal = function(qty, direction) {
          var targetVal;
          targetVal = qty;
          if (direction === '+') {
            targetVal = qty + 1;
          } else if (qty > 1) {
            targetVal = qty - 1;
          }
          return $input.val(targetVal);
        };
        return $mod.on('click', function(ev) {
          var direction, qty;
          direction = $(this).attr('js-cart-quantity');
          qty = Number($input.val());
          return adjustVal(qty, direction);
        });
      };
    })(this))();
  };

  root.components.swiper = function($element, args) {
    var swiper;
    swiper = $element.swiper(args);
    return swiper;
  };

  root = typeof exports !== "undefined" && exports !== null ? exports : this;

  messages = {
    add_cart_error: 'Oops! %s',
    add_cart_success: 'Success! Added <strong>%s</strong> to the Cart'
  };

  format = function() {
    var j, len, message, out, replacement, replacements;
    message = arguments[0], replacements = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    out = message;
    for (j = 0, len = replacements.length; j < len; j++) {
      replacement = replacements[j];
      out = out.replace('%s', replacement);
    }
    return out;
  };

  formData = function(form) {
    var data;
    data = {};
    form.serializeArray().map(function(x) {
      return data[x.name] = x.value;
    });
    return data;
  };

  navbarNotify = function(message, options) {
    var errorClass, notification, text;
    if (options == null) {
      options = {};
    }
    notification = $('.navbar__notification');
    text = notification.find('.navbar__notification__text');
    errorClass = 'navbar__notification--error';
    text.html(message);
    notification.css('background-color', options.color || '#333');
    if (options.error) {
      notification.addClass(errorClass);
    }
    notification.children().fadeIn(500);
    return notification.slideDown(400, function() {
      var hideNotification;
      hideNotification = function() {
        notification.children().fadeOut(400);
        return notification.slideUp(400, function() {
          notification.css('background-color', null);
          options.done();
          if (options.error) {
            return notification.removeClass(errorClass);
          }
        });
      };
      return setTimeout(hideNotification, 1200);
    });
  };

  desktopViewport = function() {
    return $(window).width() >= '700';
  };

  on_desktop = function(f) {
    if (desktopViewport() && f) {
      return f();
    }
  };

  on_mobile = function(f) {
    if (!desktopViewport() && f) {
      return f();
    }
  };

  root.controllers.product = function($element, args) {
    var initGallery, initStaticSelect, reloadSwiper;
    (initGallery = function() {
      var $swiper, $thumbnailImages, selectedClass, selectorClickHandler, swipeHandler;
      selectedClass = 'product__gallery-selector__option--selected';
      $thumbnailImages = $('[js-role="image-gallery__selector"]').children();
      $swiper = $('[js-role="image-gallery__viewport"]');
      selectorClickHandler = function() {
        var index;
        index = $thumbnailImages.filter(':visible').index($(this));
        return swiper.slideTo(index);
      };
      swipeHandler = function(swiper) {
        var $active;
        $active = $($thumbnailImages[swiper.activeIndex]);
        $thumbnailImages.removeClass(selectedClass);
        return $active.addClass(selectedClass);
      };
      this.swiper = $swiper.swiper({
        effect: 'fade',
        fade: {
          crossFade: true
        },
        simulateTouch: true,
        speed: 500,
        onSlideChangeStart: swipeHandler,
        onTransitionEnd: swipeHandler
      });
      $thumbnailImages.on('click', selectorClickHandler);
      return $thumbnailImages.on('tap', selectorClickHandler);
    })();
    reloadSwiper = function(option1) {
      var $active, $toggleable;
      $toggleable = $("[data-visibility-toggle]");
      $toggleable.hide();
      $active = $toggleable.filter("[data-option-1=\"" + option1 + "\"]");
      $active.show();
      this.swiper.update();
      this.swiper.onResize();
      window.swiper = this.swiper;
      return console.log("active", $active, $toggleable);
    };
    return (initStaticSelect = function() {
      var $buy, $comparePrice, $price, $rows, buyText, outOfStockText;
      $rows = $("[data-table-variant-row");
      $price = $("[js-product-price]");
      $comparePrice = $("[js-product-compare-price]");
      $buy = $("[js-buy-button]");
      outOfStockText = $buy.data('out-of-stock-text');
      buyText = $buy.text();
      $rows.on('click', function() {
        var $selected, available, comparePrice, option1, price;
        $selected = $(this);
        $rows.removeClass('is-active');
        $selected.addClass('is-active');
        $("input[name=\"id\"]").val($(this).data('variant-id'));
        price = $selected.data('price');
        comparePrice = $selected.data('compare-price');
        option1 = $selected.data('option-1');
        reloadSwiper(option1);
        $price.html(price);
        $comparePrice.html(comparePrice);
        available = $selected.data('available');
        if (available) {
          $buy.removeAttr('disabled');
          return $buy.text(buyText);
        } else {
          $buy.attr('disabled', 'true');
          return $buy.text(outOfStockText);
        }
      });
      return $rows.filter(":first").click();
    })();
  };

  root.controllers.buyForm = function(form, args) {
    var lock, successHandler, unlock;
    lock = {
      value: false
    };
    unlock = function() {
      return lock.value = false;
    };
    successHandler = function(data, result) {
      return function() {
        if (result.status) {
          return navbarNotify((format(messages.add_cart_error, result.description))({
            done: unlock
          }));
        } else {
          return navbarNotify(format(messages.add_cart_success, result.title), {
            error: true,
            done: unlock
          });
        }
      };
    };
    return form.submit(function(event) {
      var data;
      event.preventDefault();
      if (!lock.value) {
        lock.value = true;
        data = formData(form);
        return CartJS.addItem(data.id, 1, {}, {
          success: function(result) {
            return setTimeout(successHandler(data, result), 1);
          },
          error: function(error) {
            console.error('Error adding cart product!', error);
            if (error.responseJSON.description) {
              alert(error.responseJSON.description);
            }
            return unlock();
          }
        });
      }
    });
  };

  root.controllers.sampleKitQuestions = function(container, args) {
    return container.find('.product__question').each((function(_this) {
      return function(i, rawElement) {
        var animateOpacity, answer, element, text, toggleText;
        element = $(rawElement);
        text = element.find('.product__question__text');
        text.addClass('question-visible');
        answer = element.find('.product__question__answer');
        animateOpacity = function(element, value, duration, done) {
          return element.animate({
            opacity: value
          }, duration, 'linear', done);
        };
        toggleText = function(text, done) {
          if (text.hasClass('question-visible')) {
            console.log('Hiding text');
            on_desktop(function() {
              return animateOpacity(text, 0, 400, done);
            });
            on_mobile(done);
          } else {
            console.log('Showing text');
            animateOpacity(text, 1, 400, done);
          }
          return text.toggleClass('question-visible');
        };
        return element.click(function() {
          return toggleText(text, function() {
            if (answer.is(':visible')) {
              return answer.slideUp(200, function() {
                element.toggleClass('product__question--expanded');
                return toggleText(text);
              });
            } else {
              element.toggleClass('product__question--expanded');
              return answer.slideDown(300, function() {
                return toggleText(text);
              });
            }
          });
        });
      };
    })(this));
  };

  root.controllers.indexImage = function($element, args) {

    /* Choose random index image / coord pair
     */
    var $coords, asset, assets, randomIndex;
    console.log('index image', args);
    assets = args.assets;
    randomIndex = [Math.floor(Math.random() * assets.length)];
    asset = assets[randomIndex];
    $coords = $element.find('[js-index-coords]');
    $coords.html(asset.coords);
    $element.css({
      backgroundImage: "url(" + asset.image + ")",
      opacity: 0
    });
    _.delay((function(_this) {
      return function() {
        return $element.animate({
          opacity: 1
        }, 500);
      };
    })(this), 300);
    return $element.addClass('is-loaded');
  };

  root.controllers.animatedCoordinates = function($element, args) {
    var circle_split, e, latitude, latitude_direction, longitude, longitude_direction, strip, whitespace_split;
    try {
      strip = function(s) {
        return s.replace(/^\s+|\s+$/g, '');
      };
      circle_split = strip($element.text()).split(/[°º]/);
      latitude = strip(circle_split[0]);
      longitude_direction = strip(circle_split[circle_split.length - 1]);
      whitespace_split = strip(circle_split[1]).split(/\s+/);
      longitude = strip(whitespace_split[whitespace_split.length - 1]);
      latitude_direction = strip(whitespace_split[0]);
      return $element.html(['<span class="coordinate">', latitude, '</span>° ', latitude_direction, '<span class="coordinate">', longitude, '</span>° ', longitude_direction].join(''));
    } catch (_error) {
      e = _error;
      console.warn('Invalid coordinate "' + $element.text() + '" on element', $element);
      return console.warn(e);
    }
  };

  root.controllers.joinTrigger = function($element, args) {
    var $dropdown, $navbar, $pageContent;
    $dropdown = $('.navbar-dropdown--join');
    $navbar = $('.navbar');
    $pageContent = $('#page-content');
    $pageContent.click(function() {
      $dropdown.slideUp();
      return $navbar.removeClass('navbar--expanded');
    });
    return $element.click(function() {
      $dropdown.slideToggle();
      return $navbar.toggleClass('navbar--expanded');
    });
  };

  root.controllers.expandable = function($element, args) {
    var $trigger;
    $trigger = $element.find('[js-role="trigger"]');
    return $trigger.click(function() {
      var $target;
      $target = $element.find('[js-role="target"]');
      return $target.slideToggle();
    });
  };

  root.controllers.indexSignup = function($element, args) {
    var $email, $form, $submit, onAjaxChimpPOST, redirectToKOLIfFound;
    $form = $element;
    $email = $element.find('[js-index-signup-email]');
    $submit = $element.find('[js-index-signup-submit]');
    (redirectToKOLIfFound = function() {
      var kol_share_page_url;
      if (window.location.search && window.location.search.indexOf('kolid') >= 0) {
        kol_share_page_url = 'https://escape.abbottnyc.com' + window.location.search;
        root.utils.cookies.set('referral-signup-url', kol_share_page_url);
        return window.location.href = kol_share_page_url;
      } else {

      }
    })();
    onAjaxChimpPOST = function(data) {
      var $button, $error, email, msg, url;
      $error = $element.find('[js-mailchimp-error]');
      $element.removeClass('is-error');
      $error.html('');
      if (data.result === 'error') {
        $element.addClass('is-error');
        if (data.msg && data.msg.indexOf(' - ') >= 0) {
          msg = data.msg.split(' - ')[1];
        } else {
          msg = data.msg;
        }
        $error.html(msg);
        return console.log('Error from ajaxChimp ', data);
      } else if (data.result === 'success') {
        $button = $element.find('input[type="submit"]');
        email = $email.val();
        url = "http://abbottnyc.kickoffpages.com/#" + email;
        console.log('moving to url ', url);
        return window.location.href = url;
      } else {
        return console.log('Unhandled AJAXChimp Response: ', da);
      }
    };
    $email.on('keypress', function(ev) {
      var email, url;
      email = $email.val();
      if (ev.keyCode === 13) {
        url = "/pages/referral#" + email;
        return window.location.href = url;
      }
    });
    return $submit.on('click', function() {
      var email, url;
      email = $email.val();
      url = "/pages/referral#" + email;
      return window.location.href = url;
    });
  };

  root.controllers.signupForm = function($element, args) {
    var $email, $submit, onInit;
    $email = $element.find('[js-signup-email]');
    (onInit = (function(_this) {
      return function() {
        var email, hash;
        hash = window.location.hash;
        if (hash && hash.length > 1) {
          email = hash.substr(1);
          return $email.val(email);
        }
      };
    })(this))();
    $submit = $element.find('[js-form-proceed]');
    return $submit.on('click', (function(_this) {
      return function() {
        return console.log('submitting... to Mailchimp, then redirect to KOL');
      };
    })(this));
  };

  root.controllers.share = function($element, args) {
    var $progressBar, fixWidths, getGoals, getGoalsMobile, getLeader, getTopScorer, handleProgressBarDesktop, handleProgressBarMobile, handleSelectOnClick, setFriendsReferred, shareCount;
    (handleSelectOnClick = function() {
      return $("#kol-social-url").on('click', function() {
        var range, selection;
        console.log("Selecting");
        range = void 0;
        selection = void 0;
        if (window.getSelection) {
          selection = window.getSelection();
          range = document.createRange();
          range.selectNodeContents(this);
          selection.removeAllRanges();
          selection.addRange(range);
        } else if (document.body.createTextRange) {
          range = document.body.createTextRange();
          range.moveToElementText(this);
          range.select();
        }
      });
    })();
    setFriendsReferred = (function(_this) {
      return function() {
        var $target;
        $target = $element.find('[js-friends-referred]');
        return $target.html($("#referred").text());
      };
    })(this);
    setTimeout(setFriendsReferred, 1000);
    shareCount = Number(args.shareCount);
    $progressBar = $element.find('[js-share-progress-bar]');
    getLeader = (function(_this) {
      return function() {
        var $target, currentLeader;
        $target = $("#kol_leader_board_results tbody tr:first-child td:eq(2)");
        console.log('getting leader', $target);
        return currentLeader = Number($target.text());
      };
    })(this);
    getGoals = function() {
      var currentLeader;
      if (!this._getGoals) {
        this._getGoals = args.goals;
        currentLeader = getLeader();
        $('[js-top-referral-target]').html(currentLeader);
        console.log('Current Leader', currentLeader);
        console.log("Comparing current leader to 4th element", currentLeader, this._getGoals[2]);
        if (currentLeader > this._getGoals[2]) {
          $(".share__reward-goal--mobile-last").attr('data-goal-count', currentLeader);
          this._getGoals.push(currentLeader);
          console.log(' got goals once.. appended leader. ', this._getGoals);
        }
      }
      return this._getGoals;
    };
    getGoalsMobile = function() {
      if (!this._getGoalsMobile) {
        this._getGoalsMobile = getGoals();
      }
      return this._getGoalsMobile;
    };
    (fixWidths = function() {
      var $progress, width;
      if ($(window).width() < 850) {
        return;
      }
      $progress = $(".share__reward-progress:visible");
      width = $(".share__reward-image:first").outerWidth();
      return $progress.css('width', width);
    })();
    handleProgressBarDesktop = function() {
      var $goals, $maxGoal, absolutePxProgress, activatePreviousTiers, getPreviousAndNextGoalIndex, getPxProgressInLastStretch, getPxProgressUntilPreviousMetGoal, goals, maxGoal, maxGoalIndex, nextIndex, previousAndNext, previousIndex;
      if ($(window).width() < 850) {
        return;
      }
      fixWidths();
      $goals = $element.find('[data-goal-count]:visible');
      goals = getGoals();
      console.log('got goals: ', goals);
      maxGoal = goals[0];
      maxGoalIndex = 0;
      $maxGoal = $($goals[1]);
      shareCount = window.shareCountOverride || shareCount;
      console.log('share count is ', shareCount);
      getPreviousAndNextGoalIndex = function() {
        var goal, goalNumber, index, j, len, next, previous;
        previous = -1;
        next = 0;
        for (index = j = 0, len = $goals.length; j < len; index = ++j) {
          goal = $goals[index];
          goalNumber = goals[index];
          console.log("Checking " + index + ", " + shareCount + ", " + goalNumber);
          if (shareCount >= goalNumber) {
            console.log("Checking " + shareCount + " " + goal + " at index " + index + ". goals[" + index + "] = " + goalNumber);
            previous += 1;
            next += 1;
            console.log("Next is now " + next + " and previous is now " + previous);
          } else {
            console.log("Fail: share count " + shareCount + " is < " + index + " " + goalNumber);
            break;
          }
        }
        console.log("Ensuring next " + next + " is not greater than max value of " + ($goals.length - 1));
        if (next > ($goals.length - 1)) {
          next = $goals.length - 1;
          console.log("Setting next value to " + next);
        }
        return [previous, next];
      };
      previousAndNext = getPreviousAndNextGoalIndex();
      previousIndex = previousAndNext[0];
      nextIndex = previousAndNext[1];
      console.log('For given share count ', shareCount);
      console.log('Found previous index: ', previousIndex);
      console.log('Found next index: ', nextIndex);
      (activatePreviousTiers = function() {
        return $goals.filter(":lt(" + (previousIndex + 1) + ")").addClass('share__reward-goal--active');
      })();
      getPxProgressUntilPreviousMetGoal = function() {
        return $goals.eq(previousIndex).position().left;
      };
      getPxProgressInLastStretch = function() {
        var lastStretchPx, lastStretchQty, nextGoalQty, percentageProgress, prevGoalQty, px, pxProgress, qtyPastLastGoal;
        px = $goals.eq(nextIndex).position().left;
        prevGoalQty = goals[previousIndex];
        nextGoalQty = goals[nextIndex];
        console.log("Previous goal qty (" + prevGoalQty + " vs next goal qty (" + nextGoalQty + ")");
        qtyPastLastGoal = shareCount - prevGoalQty;
        console.log("Qty past last goal " + qtyPastLastGoal);
        lastStretchQty = nextGoalQty - prevGoalQty;
        console.log("Last stretch quantity is " + lastStretchQty);
        if (lastStretchQty === 0) {
          percentageProgress = 1;
        } else {
          percentageProgress = qtyPastLastGoal / lastStretchQty;
        }
        console.log("Percentage progress through last step " + percentageProgress);
        lastStretchPx = px - getPxProgressUntilPreviousMetGoal();
        pxProgress = lastStretchPx * percentageProgress;
        console.log(lastStretchPx + " * " + percentageProgress + " = " + pxProgress);
        return pxProgress;
      };
      absolutePxProgress = getPxProgressUntilPreviousMetGoal() + getPxProgressInLastStretch();
      if ($(window).width() < 850) {
        return $progressBar.css({
          width: ''
        });
      } else {
        return $progressBar.css({
          width: absolutePxProgress,
          height: '3px'
        });
      }
    };
    handleProgressBarMobile = function() {
      var $goals, $maxGoal, $previousGoal, absolutePxProgress, goal, goals, index, isMobile, j, lastStretchPx, len, maxGoal, maxGoalIndex, nextGoalQty, previousGoal, previousGoalOffsetLeft, previousGoalQty, progressToNextGoalPercentage, pxDistanceInLastStretch, pxDistanceOffset, qtyAfterLastGoal, qtyDistanceInLastStretch;
      if ($(window).width() > 850) {
        return;
      }
      isMobile = true;
      $goals = $element.find('.share__reward-goal:visible');
      goals = getGoalsMobile();
      console.log('got goals mobile: ', goals);
      maxGoal = goals[0];
      maxGoalIndex = 0;
      shareCount = window.shareCountOverride || shareCount;
      console.log('share count mobile is ', shareCount);
      for (index = j = 0, len = goals.length; j < len; index = ++j) {
        goal = goals[index];
        if (shareCount >= Number(goal)) {
          $goals.eq(index).addClass('share__reward-goal--active');
          console.log("M: Share count > than", shareCount, goal);
          if (index === 4) {
            maxGoalIndex = 4;
          } else {
            maxGoalIndex = index + 1;
          }
          maxGoal = goals[maxGoalIndex];
          $maxGoal = $($goals[maxGoalIndex]);
        }
        console.log('goal iteration: ', index, 'shareCount: ', shareCount, 'goal: ', goal, ' Max is currently: ', maxGoal);
      }
      nextGoalQty = goals[maxGoalIndex];
      if (maxGoalIndex !== 0) {
        $previousGoal = $goals.eq(maxGoalIndex - 1);
        previousGoalOffsetLeft = $previousGoal.position().top;
        previousGoal = $previousGoal.attr('data-goal-count');
        previousGoalQty = Number(previousGoal);
      } else {
        previousGoalOffsetLeft = 0;
        previousGoalQty = 0;
      }
      console.log(previousGoalOffsetLeft, 'offset');
      qtyDistanceInLastStretch = nextGoalQty - previousGoalQty;
      qtyAfterLastGoal = shareCount - previousGoalQty;
      progressToNextGoalPercentage = qtyAfterLastGoal / qtyDistanceInLastStretch;
      if (progressToNextGoalPercentage > 1) {
        progressToNextGoalPercentage = 1;
        pxDistanceOffset = 0;
      } else {
        pxDistanceOffset = 0;
      }
      console.log('Previous Goal: ', previousGoalQty);
      console.log('Next Goal: ', nextGoalQty);
      console.log("Current count: ", shareCount);
      console.log("Distance To Next Goal: ", qtyDistanceInLastStretch);
      console.log("Qty after last goal: ", qtyAfterLastGoal);
      console.log("Progress to next goal: ", progressToNextGoalPercentage);
      pxDistanceInLastStretch = $maxGoal.position().top - previousGoalOffsetLeft;
      lastStretchPx = pxDistanceInLastStretch * progressToNextGoalPercentage;
      absolutePxProgress = previousGoalOffsetLeft + lastStretchPx + pxDistanceOffset;
      console.log("M: PreviousGoalOffsetLeft: ", previousGoalOffsetLeft);
      console.log("M: lastStretchPx", lastStretchPx);
      console.log('M: absolute px', absolutePxProgress);
      if ($(window).width() < 850) {
        return $progressBar.css({
          width: '3px',
          height: absolutePxProgress
        });
      } else {
        return $progressBar.css({
          height: ''
        });
      }
    };
    $(window).on('resize', handleProgressBarDesktop);
    $(window).on('resize', handleProgressBarMobile);
    setTimeout(function() {
      handleProgressBarMobile();
      return handleProgressBarDesktop();
    }, 2000);
    return (getTopScorer = function() {
      var LEADERBOARD_URL, result;
      LEADERBOARD_URL = 'http://simple-leaderboard-30.kickoffpages.com/';
      result = $(".not_current_user:first-child td:eq(3)");
      return 100;
    })();
  };

  root.controllers.mobileNavbar = function($element, args) {
    var dropdownSelector, subnavSelector, toggleExpandedClass, toggleSelector;
    subnavSelector = '[js-role="subnav"]';
    toggleSelector = '[js-role="subnav__toggle"]';
    dropdownSelector = '[js-role="subnav__dropdown"]';
    toggleExpandedClass = 'mobile-navbar__item--expanded';
    return $element.find(subnavSelector).each(function(i, rawSubnav) {
      var $dropdown, $subnav, $toggle;
      $subnav = $(rawSubnav);
      $toggle = $subnav.find(toggleSelector);
      $dropdown = $subnav.find(dropdownSelector);
      return $toggle.click(function() {
        $toggle.toggleClass(toggleExpandedClass);
        return $dropdown.slideToggle();
      });
    });
  };

  root.controllers.navbar = function($element, args) {
    var handleMobileNavbar, handleStickyNavbar;
    (handleMobileNavbar = (function(_this) {
      return function() {
        var $close, $overlay, $trigger;
        $trigger = $element.find('[js-mobile-navbar-trigger]');
        $overlay = $('[js-mobile-navbar]');
        _this.clsAnimateIn = 'mobile-navbar--animate-in';
        _this.clsAnimateOut = 'mobile-navbar--animate-out';
        $close = $overlay.find('[js-mobile-navbar-close]');
        _this.open = function() {
          $overlay.removeClass(_this.clsAnimateOut);
          $overlay.fadeIn('fast', function() {
            return $overlay.addClass(_this.clsAnimateIn);
          });
          $element.addClass('navbar--mobile-open');
          return $('html').addClass('navbar-mobile-open');
        };
        _this.close = function() {
          $element.removeClass('navbar--mobile-open');
          $overlay.removeClass(_this.clsAnimateIn);
          $overlay.addClass(_this.clsAnimateOut);
          $overlay.fadeOut();
          return $('html').removeClass('navbar-mobile-open');
        };
        $(document).keyup(function(e) {
          if (e.keyCode === 27) {
            return _this.close();
          }
        });
        $trigger.on('click', function() {
          if ($overlay.is(':visible')) {
            return _this.close();
          } else {
            return _this.open();
          }
        });
        return $close.on('click', function() {
          return _this.close();
        });
      };
    })(this))();
    console.log('init navbar');
    return (handleStickyNavbar = (function(_this) {
      return function() {
        var $mark, $window, STICK_THRESHOLD, handleLogoMarkRotation, handleStickyClasses, pixelsPerRotation;
        STICK_THRESHOLD = 8;
        $window = $(window);
        handleStickyClasses = function() {
          var scrollTop;
          scrollTop = $window.scrollTop();
          if (scrollTop > STICK_THRESHOLD) {
            if ($element.hasClass('navbar--docked')) {
              $element.removeClass('navbar--docked');
            }
            return $element.addClass('navbar--is-sticky');
          } else {
            $element.removeClass('navbar--is-sticky');
            return $element.addClass('navbar--docked');
          }
        };
        handleStickyClasses();
        $mark = $element.find('[data-logo-mark-a]');
        pixelsPerRotation = 2500;
        handleLogoMarkRotation = function() {
          var degrees, degreesAlreadyLooped, degreesRemainder, fullLoops, loopRemainder, top;
          if ($window.width() < 500) {
            return;
          }
          top = $window.scrollTop() - 10;
          fullLoops = Math.floor(top / pixelsPerRotation);
          loopRemainder = top % pixelsPerRotation;
          degreesRemainder = (loopRemainder / pixelsPerRotation) * 360;
          degreesAlreadyLooped = fullLoops * 360;
          degrees = degreesAlreadyLooped + degreesRemainder;
          if (degrees < 0) {
            degrees = 0;
          }
          return $mark.css({
            transform: "rotate(" + degrees + "deg)"
          });
        };
        return $window.on('scroll', function(ev) {
          console.log('scrolling');
          handleStickyClasses();
          handleLogoMarkRotation();
          ev.preventDefault();
          return ev.stopPropagation();
        });
      };
    })(this))();
  };

  root.controllers.journeyModuleStacked = function($element, args) {
    var $large, $small, resize, variant;
    $small = $element.find('[js-journey-module-stacked-small-img]');
    $large = $element.find('[js-journey-module-stacked-large-img]');
    variant = args.variant.split('-')[0];
    console.log("INIT: ", args);
    (resize = (function(_this) {
      return function() {
        var distance_from_left_edge, distance_from_right_edge, height, large_left_edge, large_right_edge, left_margin, right_margin, small_width, target_left_edge, target_right_edge, total_width;
        height = $small.height() / 2;
        console.log("variatN", variant);
        switch (variant) {
          case 'bottom':
            $element.css({
              paddingTop: '',
              paddingBottom: height
            });
            break;
          case 'top':
            $element.css({
              paddingBottom: '',
              paddingTop: height
            });
        }
        switch (args.alignment) {
          case 'left':
            left_margin = $large.offset().left;
            small_width = $small.width();
            total_width = $(window).width();
            target_right_edge = total_width - left_margin;
            large_right_edge = $large.width() + left_margin;
            distance_from_right_edge = target_right_edge - large_right_edge;
            return $small.css({
              marginRight: -1 * distance_from_right_edge
            });
          case 'right':
            right_margin = $(window).width() - $large.offset().left - $large.width();
            small_width = $small.width();
            total_width = $(window).width();
            target_left_edge = right_margin;
            large_left_edge = $large.offset().left;
            distance_from_left_edge = large_left_edge - target_left_edge;
            return $small.css({
              marginLeft: -1 * distance_from_left_edge
            });
        }
      };
    })(this))();
    $(window).on('resize', resize);
    return $element.find('img').on('load', resize).each(function() {
      return $(this).load();
    });
  };

  root.controllers.redirectToShareIfFound = function($element, args) {
    var redirectToSharePageIfCookieFound;
    return (redirectToSharePageIfCookieFound = function() {
      var url;
      url = root.utils.cookies.get('referral-signup-url');
      console.log('checking for cookie', url);
      if (url && url.length > 0) {
        return window.location.href = url;
      }
    })();
  };

  root.controllers.referralForm = function($element) {
    var applyError, getInputNamed, handleHash, kolSubmit, redirectToKOLIfFound, removeError, setAllowVisitorsCookie, showErrors, showSignupError, validate, validateEmail;
    (redirectToKOLIfFound = function() {
      var kol_share_page_url;
      if (window.location.search && window.location.search.indexOf('kolid') >= 0) {
        kol_share_page_url = 'http://escape.abbottnyc.com' + window.location.search;
        root.utils.cookies.set('referral-signup-url', kol_share_page_url);
        root.utils.cookies.set('referral-signed-up', true);
        return window.location.href = kol_share_page_url;
      }
    })();
    showSignupError = function() {
      return setTimeout(function() {
        var $error, html;
        html = '<div class="error"> Sign up to Get Access! </div>';
        console.log('errors are ', html);
        $error = $(".content__error");
        if (!$error.length) {
          console.log('error div not found, injecting');
          $error = $("<div class='content__error'></div>");
          $error.hide();
          $error.prependTo($(".content__bg"));
          $error.slideDown();
        }
        return $error.html(html);
      }, 500);
    };
    (handleHash = function() {
      var error_hash_value, hash;
      error_hash_value = 'signup-to-gain-access';
      hash = window.location.hash;
      if (hash && hash.length > 0) {
        hash = hash.substr(1);
        if (hash === error_hash_value) {
          return showSignupError();
        } else {
          return $("[name='email']").val(hash);
        }
      }
    })();
    try {
      $($("input").eq(1)).focus();
    } catch (_error) {

    }
    getInputNamed = function(name) {
      return $element.find("[name=\"" + name + "\"]");
    };
    validateEmail = function() {
      var $email, email, re, results, valid;
      $email = getInputNamed('email');
      email = $email.val();
      results = {
        valid: false,
        input: $email,
        errorMessage: 'Please enter a valid email address'
      };
      if (email === '') {
        results.errorMessage = 'Enter your email below to get rewards and order scents';
        return results;
      }
      re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      valid = re.test(email);
      if (valid) {
        results.valid = true;
      }
      return results;
    };
    applyError = function($input) {
      if (!$input.hasClass('input-wrapper')) {
        $input = $input.closest('.input-wrapper');
      }
      return $input.addClass('error');
    };
    removeError = function($input) {
      if (!$input.hasClass('input-wrapper')) {
        $input = $input.closest('.input-wrapper');
      }
      return $input.removeClass('error');
    };
    validate = function() {
      var errors, j, len, results, validator, validators;
      validators = [validateEmail];
      errors = [];
      for (j = 0, len = validators.length; j < len; j++) {
        validator = validators[j];
        results = validator();
        if (!results.valid) {
          errors.push(results);
          applyError(results.input);
        } else {
          removeError(results.input);
        }
      }
      if (errors.length === 0) {
        return true;
      }
      showErrors(errors);
      return false;
    };
    showErrors = function(errors) {
      var $error, error, html, j, len, target;
      console.log('showing errors', errors);
      html = '';
      for (j = 0, len = errors.length; j < len; j++) {
        error = errors[j];
        html += '<div class="error">' + error.errorMessage + '</div>';
      }
      console.log('errors are ', html);
      $error = $(".content__error");
      if (!$error.length) {
        console.log('error div not found, injecting');
        $error = $("<div class='content__error'></div>");
        $error.hide();
        $error.appendTo($element);
        $error.slideDown();
      }
      target = $error.offset().top - 50;
      $('html, body').animate({
        scrollTop: target
      }, 750);
      return $error.html(html);
    };
    window.validate = validate;
    setAllowVisitorsCookie = function() {
      return root.utils.cookies.set('referral-signed-up', true);
    };
    kolSubmit = function() {
      setAllowVisitorsCookie();
      return $('#submit_button').click();
    };
    $("form input").on('keypress', function(ev) {
      var valid;
      if (ev.keyCode === 13) {
        valid = validate();
        if (!valid) {
          ev.preventDefault();
          ev.stopPropagation();
          return false;
        } else {
          return kolSubmit();
        }
      }
    });
    return $("[js-form-proceed]").on('click', function(ev) {
      var valid;
      valid = validate();
      if (valid) {
        return kolSubmit();
      } else {
        ev.preventDefault();
        return ev.stopPropagation();
      }
    });
  };

  root.controllers.restrictedAccessLink = function($element, args) {

    /* Only allow access to these pages, if they have a valid signup cookie,
    or a certain hash parameter is in the URL.
     */
    var bypassHash, checkIfAllowedAccess, cookieValue, isBypassed;
    bypassHash = 'direct';
    cookieValue = 'abbott-referral-access-granted';
    isBypassed = function() {
      if (window.location.hash && (window.location.hash.substr(1) === bypassHash)) {
        return true;
      }
      return false;
    };
    checkIfAllowedAccess = function() {
      if (isBypassed()) {
        console.log("Restricted access link. Setting cookie");
        root.utils.cookies.set('referral-signed-up', true);
        return true;
      }
      cookieValue = root.utils.cookies.get(cookieValue);
      if (cookieValue && cookieValue.length > 1) {
        return true;
      }
      return false;
    };
    $element.css({
      cursor: 'pointer'
    });
    return $element.on('click', function() {
      var allowed;
      allowed = checkIfAllowedAccess();
      if (!allowed) {
        window.location.href = 'http://abbottnyc.com/pages/referral#signup-to-gain-access';
        return console.log('not allowed');
      } else {
        window.location.href = args.href;
        return console.log('allowed');
      }
    });
  };

  root.controllers.cartItem = function($element, args) {
    var $linePrice, $price, $quantity, $subtotal, $triggers, handleCartItemMessage;
    $triggers = $element.find('[js-cart-quantity]');
    $quantity = $element.find('[js-cart-quantity-input]');
    $price = $element.find('[js-cart-price]');
    $linePrice = $element.find('[js-cart-line-price]');
    $subtotal = $('[js-cart-subtotal]');
    $triggers.on('click', function() {
      var value;
      value = $(this).attr('js-cart-quantity');
      return setTimeout(function() {
        var cart;
        cart = $.ajax({
          url: '/cart/change.js',
          dataType: 'json',
          data: {
            line: args.index,
            quantity: $quantity.val()
          },
          success: function(data) {
            var item_data;
            console.log('updated', data);
            item_data = data.items[args.index - 1];
            $price.html('$' + (item_data.price / 100).toFixed(2));
            $linePrice.html('$' + (item_data.line_price / 100).toFixed(2));
            $subtotal.html('$' + (data.total_price / 100).toFixed(2));
            return console.log($subtotal);
          },
          complete: function() {
            return console.log('complete');
          }
        });
        return console.log('changing qty to... ', $quantity.val());
      }, 100);
    });
    return (handleCartItemMessage = function() {
      var $close, $edit, $message, $popup, hide, initSave, show;
      $message = $element.find('[data-cart-item-message]');
      if (!$message.length) {
        return;
      }
      $popup = $message.find('[data-cart-item-popup]');
      show = function(ev) {
        $popup.fadeIn();
        $popup.find('textarea').focus();
        if (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          return false;
        }
      };
      hide = function() {
        return $popup.fadeOut();
      };
      (initSave = function() {
        var $save;
        $save = $popup.find('[data-cart-item-save]');
        return $save.on('click', function() {
          var $textarea, val;
          $textarea = $popup.find('textarea');
          val = $textarea.val();
          return $.ajax({
            url: '/cart/change.js',
            dataType: 'json',
            data: {
              line: args.index,
              quantity: $quantity.val(),
              properties: {
                'Gift Message': val
              }
            },
            success: function(data) {
              var item_data;
              item_data = data.items[args.index - 1];
              console.log('updated', data, item_data);
              return window.location.reload();
            }
          });
        });
      })();
      $edit = $message.find('[data-cart-item-message-edit]');
      $edit.on('click', show);
      $close = $popup.find('[data-cart-item-popup-close]');
      return $close.on('click', hide);
    })();
  };

  root.controllers.cartItemMessage = function($element, args) {};

  root.controllers.redirectIfNotPermitted = function($element, args) {
    var permitted, redirect;
    permitted = function() {
      var PERMITTED_COOKIE_NAME, PERMITTED_HASH, hash;
      PERMITTED_COOKIE_NAME = 'referral-signed-up';
      PERMITTED_HASH = 'direct';
      hash = window.location.hash;
      console.log("Checking permissions with hash", hash);
      if (hash && hash.substr(1) === PERMITTED_HASH) {
        return true;
      }
      if (!root.utils.cookies.get(PERMITTED_COOKIE_NAME)) {
        console.log("Permission cookie not set. False");
        return false;
      }
      console.log("Permission cookie set");
      return true;
    };
    redirect = function() {
      console.log("Not permitted, redirecting");
      return window.location.href = 'https://abbottnyc.com/pages/referral#signup-to-gain-access';
    };
    if (!permitted()) {
      return redirect();
    } else {
      return root.utils.cookies.set('referral-signed-up', true);
    }
  };

  root.controllers.shopPreorder = function($element, args) {
    var $els;
    $els = $element.find('.shop-wide, .shop-product');
    if ($("html").hasClass('supports-no-touch')) {
      $els.on('click mouseenter', function() {
        var $overlays;
        $('.shop-product__overlay, .shop-wide__overlay').hide();
        $overlays = $(this).find('.shop-product__overlay, .shop-wide__overlay');
        return $overlays.hide().fadeIn('fast');
      });
      return $els.on('mouseleave', function() {
        return $('.shop-product__overlay, .shop-wide__overlay').fadeOut('fast');
      });
    }
  };

  root.controllers.resetPassowrd = function($element, args) {
    var e;
    try {
      return console.log('');
    } catch (_error) {
      e = _error;
      return console.log(e);
    }
  };

  root.controllers.accountLogin = function($element, args) {
    var e;
    try {
      console.log('');
      return $("#RecoverPassword").on('click', function() {
        return $("#RecoverPasswordForm").slideDown();
      });
    } catch (_error) {
      e = _error;
      return console.log(e);
    }
  };

  root.controllers.indexHeader = function($element, args) {
    var $text, $top, redirectToKOLIfFound;
    $text = $element.find('[js-text]');
    $top = $element.find('[js-top]');
    return (redirectToKOLIfFound = function() {
      var kol_share_page_url;
      if (window.location.search && window.location.search.indexOf('kid') >= 0) {
        kol_share_page_url = 'http://share.abbottnyc.com' + window.location.search;
        window.location.href = kol_share_page_url;
      }
      if (window.location.search && window.location.search.indexOf('kolid') >= 0) {
        kol_share_page_url = 'http://escape.abbottnyc.com' + window.location.search;
        root.utils.cookies.set('referral-signup-url', kol_share_page_url);
        root.utils.cookies.set('referral-signed-up', true);
        return window.location.href = kol_share_page_url;
      }
    })();
  };

  root.controllers.homeSlider = function($element, args) {
    var swiper;
    return swiper = $element.swiper({
      loop: true,
      autoplay: 5000,
      effect: 'fade',
      fade: {
        crossFade: true
      },
      centeredSlides: true,
      simulateTouch: true,
      height: 'auto',
      slidesPerView: 'auto',
      lazyLoading: true,
      lazyLoadingInPrevNext: true,
      onImagesReady: function() {
        onResize();
        return $element.animate({
          'opacity': 1
        }, 1000, 'swing');
      }
    });
  };

  root.controllers.aboutSwiper = function($element, args) {
    var onResize, swiper;
    $element.css('opacity', 0);
    (onResize = function() {
      var calculateMaxHeight;
      calculateMaxHeight = function() {
        var heightToWidthRatio, maxHeight, maxWidth, width, widthRatio;
        if ($(window).width() < root.variables.breakpoints.desktop) {
          width = $(window).width() - 40;
          widthRatio = width / $(window).width();
        } else {
          widthRatio = 827 / 1332;
        }
        maxWidth = widthRatio * $(window).width();
        console.log('maxWidth: ', maxWidth);
        heightToWidthRatio = 444 / 655;
        maxHeight = heightToWidthRatio * maxWidth;
        console.log("maxHeight: " + maxHeight);
        return maxHeight;
      };
      $(".swiper-slide").css({
        height: calculateMaxHeight()
      });
      if (typeof swiper !== "undefined" && swiper !== null) {
        return swiper.update(true);
      }
    })();
    $(window).on('resize', onResize);
    swiper = $element.swiper({
      loop: true,
      centeredSlides: true,
      spaceBetween: 20,
      simulateTouch: true,
      height: 'auto',
      slidesPerView: 'auto',
      nextButton: $element.find('.about__swiper-arrow--next').get(),
      prevButton: $element.find('.about__swiper-arrow--prev').get(),
      onImagesReady: function() {
        onResize();
        return $element.animate({
          'opacity': 1
        }, 1000, 'swing');
      }
    });
    return window.swiper = swiper;
  };

  root.controllers.aboutVideo = function($element, args) {
    var $video, setSize;
    $element.data('init', true);
    $element.css('overflow', 'hidden');
    $video = $element.find('iframe');
    setSize = function() {
      var aspectRatio, fix, heightOffset, videoHeight, videoWidth, widthOffset;
      aspectRatio = 16 / 9;
      if ($element.width() / aspectRatio < $element.height()) {
        fix = 'width';
      } else {
        fix = 'height';
      }
      if (fix === 'height') {
        videoHeight = $element.width() / aspectRatio;
        videoWidth = $element.width();
        widthOffset = ($element.width() - videoWidth) / 2;
        heightOffset = 0;
      } else {
        videoHeight = $element.height();
        videoWidth = $element.height() * aspectRatio;
        heightOffset = ($element.height() - videoHeight) / 2;
        widthOffset = 0;
      }
      $video.width(videoWidth);
      $video.height(videoHeight);
      $video.css('margin-top', heightOffset);
      $video.css('margin-left', widthOffset);
      return $video.css('margin-right', widthOffset);
    };
    setSize();
    return $(window).resize(setSize);
  };

  root.controllers.footerNewsletter = function($element, args) {
    var $submit;
    root.components.mailchimp($element, {});
    $submit = $element.find('[js-newsletter-submit]');
    return $submit.on('click touchend', function() {
      return $element.submit();
    });
  };

  root.controllers.minHeight = function($element, args) {
    var setMinHeight;
    (setMinHeight = function() {
      var minHeight, navbar, outerHeight;
      navbar = $element.position().top;
      minHeight = $(window).height() - navbar;
      if ($(".footer-wrapper").is(":visible")) {
        outerHeight = $(".footer-wrapper").outerHeight();
        minHeight -= outerHeight;
      }
      return $element.css({
        minHeight: minHeight
      });
    })();
    return $(window).on('resize', _.debounce(setMinHeight, 100));
  };

  inputEmailAfterInit = function() {
    var $email, email, fired, hash, inputBlank, inputExists;
    fired = false;
    $email = $(".klaviyo-form input:visible:first");
    inputExists = $email.length > 0;
    if (!fired && inputExists) {
      fired = true;
      inputBlank = $email.val().length === 0;
      if (inputBlank) {
        hash = window.location.hash;
        if (hash.length > 1) {
          email = hash.substr(1);
          return $email.val(email);
        }
      }
    }
  };

  root.controllers.newSignupPage = function($element) {
    var hash;
    return hash = window.location.hash;
  };

  root = typeof exports !== "undefined" && exports !== null ? exports : this;

  console.log("_main.coffee");


  /*
   * Viewport - jQuery selectors for finding elements in viewport
   *
   * Copyright (c) 2008-2009 Mika Tuupola
   *
   * Licensed under the MIT license:
   *   http://www.opensource.org/licenses/mit-license.php
   *
   * Project home:
   *  http://www.appelsiini.net/projects/viewport
   *
   */

  (function($) {
    $.belowthefold = function(element, settings) {
      var fold;
      fold = $(window).height() + $(window).scrollTop();
      return fold <= $(element).offset().top - settings.threshold;
    };
    $.abovethetop = function(element, settings) {
      var top;
      top = $(window).scrollTop();
      return top >= $(element).offset().top + $(element).height() - settings.threshold;
    };
    $.rightofscreen = function(element, settings) {
      var fold;
      fold = $(window).width() + $(window).scrollLeft();
      return fold <= $(element).offset().left - settings.threshold;
    };
    $.leftofscreen = function(element, settings) {
      var left;
      left = $(window).scrollLeft();
      return left >= $(element).offset().left + $(element).width() - settings.threshold;
    };
    $.inviewport = function(element, settings) {
      return !$.rightofscreen(element, settings) && !$.leftofscreen(element, settings) && !$.belowthefold(element, settings) && !$.abovethetop(element, settings);
    };
    $.extend($.expr[':'], {
      'below-the-fold': function(a, i, m) {
        return $.belowthefold(a, {
          threshold: 0
        });
      },
      'above-the-top': function(a, i, m) {
        return $.abovethetop(a, {
          threshold: 0
        });
      },
      'left-of-screen': function(a, i, m) {
        return $.leftofscreen(a, {
          threshold: 0
        });
      },
      'right-of-screen': function(a, i, m) {
        return $.rightofscreen(a, {
          threshold: 0
        });
      },
      'in-viewport': function(a, i, m) {
        return $.inviewport(a, {
          threshold: 0
        });
      }
    });
  })(jQuery);

}).call(this);
